import PerfectScrollbar from 'perfect-scrollbar';

const ps = new PerfectScrollbar('.top-attention-content__text', {
  wheelSpeed: 2,
  wheelPropagation: true,
  minScrollbarLength: 20
});